import template from "./template.html";
import "./style.less";
import {
	TIME_DISPLAY_OPTIONS, 
	EVENT_TIMEZONE_SET, 
	PROXY_FIELDS
} from "constants.js";
import moment from "moment-timezone";

class DateTimeController {
	constructor($scope, appState, $logger, $userProfile, $timeout, eventBus) {
		this.$scope = $scope;
		this.form = appState.forms.selected;
		this.logger = $logger;
		this.appState = appState;
		this.$userProfile = $userProfile;
		this.$timeout = $timeout;
		this.eventBus = eventBus;

		this.dateOptions = {
			formatYear: "yyyy",
			startingDay: 0,
			minDate: new Date("1910-01-01")
		};
		this.popupOpen = false;
		
		this.isTimepickerShown = false;
		this.isDatepickerShown = false;
		this.suppressNextDateWatch = false;
	}

	$onChanges(changes) {
		if(changes.ngModel && !changes.ngModel.currentValue) {
			this.modelValue = undefined;
			this.timepickerDate = null;
		}
	}

	$onInit() {
		const thisUserProfile = this.$userProfile.getUserProfile();
		const ctrl = this;

		this.format = "MM/dd/yy";
		this.placeholder = "Ex. 01/01/2000";
		this.altInputFormats = [
			"M!-d!-yyyy", "M!-d!-yy",
			"M!/d!/yyyy", "M!/d!/yy",
			"M!.d!.yyyy", "M!.d!.yy",
			"shortDate"
		];
		this.modelOptions = {};

		if(this.timeZoneMode === "local") {
			this.timezoneCode = undefined;
		}
		else if(this.form.TimeMode?.Code === "BYFORM" || this.timeZoneMode === "BYFORM") {
			this.timezoneCode = this.form.TimeZone?.Code;			
		}
		else if(this.form.TimeMode?.Code === "BYENTITY" || this.timeZoneMode === "BYENTITY") {
			this.eventBus.register(
				EVENT_TIMEZONE_SET(PROXY_FIELDS.DATETIME),
				(e, params) => {
					this.timezoneCode = params.value;
				},
				this.$scope
			);
		}
		
		if(!this.isDateOnly) {
			this.isTwelveHour = thisUserProfile.timeDisplay === TIME_DISPLAY_OPTIONS.TWELVE_HOUR;
			this.format = this.isTwelveHour ? "MM/dd/yy hh:mm a" : "MM/dd/yy HH:mm";
			this.placeholder = this.isTwelveHour ? "Ex. 01/01/2000 01:00 PM" : "Ex. 01/01/2000 13:00";
			this.altInputFormats = this.isTwelveHour ?
			[
				"M!-d!-yyyy h:mma", "M!-d!-yy h:mm a", "M!-d!-yy h:mma", "M!-d!-yyyy h:mm a",
				"M!/d!/yyyy h:mma", "M!/d!/yy h:mm a", "M!/d!/yy h:mma", "M!/d!/yyyy h:mm a",
				"M!.d!.yyyy h:mma", "M!.d!.yy h:mm a", "M!.d!.yy h:mma", "M!.d!.yyyy h:mm a",
				"shortDate"
			] : [
				"M!-d!-yyyy H:mm", "M!-d!-yy H:mm", "M!-d!-yy HH:mm", "M!-d!-yyyy HH:mm",
				"M!/d!/yyyy H:mm", "M!/d!/yy H:mm", "M!/d!/yy HH:mm", "M!/d!/yyyy HH:mm",
				"M!.d!.yyyy H:mm", "M!.d!.yy H:mm", "M!.d!.yy HH:mm", "M!.d!.yyyy HH:mm",
				"shortDate"
			]; 

			this.$scope.$watch(
				() => ctrl.timepickerDate,
				(next) => {
					if(!!next) {
						this.$timeout(() => {
							ctrl.suppressNextDateWatch = true;
							ctrl.modelValue = next;
						});
					}
				},
				true
			);
		}

		if(ctrl.ngModel !== undefined) {
			let modelMoment = moment(ctrl.ngModel);
			if(this.timezoneCode !== undefined) {
				modelMoment = moment(ctrl.ngModel, "YYYY-MM-DDThh:mm:ss")
					.tz(this.timezoneCode);
			}
			ctrl.modelValue = modelMoment.toDate();
		}
		this.$scope.$watch(
			() => ctrl.modelValue,
			(next) => {
				if(!!next) {
					this.$timeout(() => {
						let nextMoment = moment(next);
						if(ctrl.valueTime?.toLowerCase() === "end") {
							nextMoment = nextMoment.add(1, "day");
						}
						else if(ctrl.valueTime?.toLowerCase() === "middle") {
							nextMoment = nextMoment.add(12, "hours");
						}

						if(this.timezoneCode !== undefined) {
							nextMoment = nextMoment.tz(this.timezoneCode, true);
						}

						this.ngModelCtrl.$setViewValue(nextMoment.format("YYYY-MM-DDTHH:mm:00Z"));
					});
				}
			},
			true
		);
	}

	handleClickOutside = () => {
		this.isTimepickerShown = false;
		this.timepickerDate = null;
	};

	openDatepicker = () => {
		this.isDatepickerShown = !this.isDatepickerShown;
	};

	openTimepicker = () => {
		if(!this.modelValue) {
			const initializedDate = new Date();
			initializedDate.setHours(0);
			initializedDate.setMinutes(0);
			initializedDate.setSeconds(0);
			initializedDate.setMilliseconds(0);
			this.modelValue = initializedDate;
		}

		this.timepickerDate = this.modelValue;

		this.isTimepickerShown = true;
	};
}

export default angular
	.module("vesl.components.datetimepicker", [])
	.component("dateTimePicker", {
		controller: DateTimeController,
		template,
		require: { ngModelCtrl: "^ngModel" },
		bindings: {
			schema: "<",
			ngModel: "<",
			isDateOnly: "<",
			valueTime: "<",
			timeZoneMode: "<"
		}
	}).name;
